module.exports = __webpack_public_path__ + "static/ogpImage_ssd-contribution-9ef688d925b53cc9182524372286b099.png";